<template>
  <div class="font-bold filter facet">
    <div v-if="!isOpen" @click="isOpen=true"
         class=" flex flex-col cursor-pointer flex-wrap w-full align-center mt-2 justify-evenly h-1/10">
      <div class="burger p-1 flex items-center self-center justify-center">
        <img src="../../../assets/icons/filter.svg" class="transform rotate-180"/>
      </div>
      <p class="transform -rotate-90 flex text-right mt-2 items-center justify-center">
        {{ getTranslation('filter') }}
      </p>
    </div>

    <div v-if="isOpen" class="flex flex-row-reverse pl-6 pt-4 flex-row">
      <div class="burger cursor-pointer w-1/10 flex items-center justify-center"
           @click="isOpen=false">
        <font-awesome-icon icon="angle-left"/>
      </div>
      <div class="w-9/10 pb-8">
        <div class="grid grid-cols-2 gap-2 mb-2">
          <p class="text-left">{{ getTranslation("articleName") }}</p>
          <c-input :idkey="0" v-model="queryData.query.articleName"
                   :name="'articleName'"></c-input>

          <p class="text-left">{{ getTranslation("articleNumber") }}</p>
          <c-input :idkey="1" v-model="queryData.query.articleNumber"
                   :name="'articleNumber'"></c-input>

          <p class="text-left">{{ getTranslation("range") }}</p>
          <c-input :idkey="1" v-model="queryData.query.rangeName" :name="'rangeName'"></c-input>

          <p class="text-left">{{ getTranslation("dimensions") }}</p>
          <div class="grid grid-cols-3 gap-2">
            <c-input :idkey="3" v-model="queryData.query.length" :name="'length'" type="number"
                     :placeholder="'L'"></c-input>
            <c-input :idkey="4" v-model="queryData.query.width" :name="'width'" type="number"
                     :placeholder="'W'"></c-input>
            <c-input :idkey="5" v-model="queryData.query.height" :name="'height'" type="number"
                     :placeholder="'T'"></c-input>
          </div>

          <p class="text-left">{{ getTranslation("decorName") }}</p>
          <c-input :idkey="6" v-model="queryData.query.decorName" :name="'decorName'"></c-input>

          <p class="text-left">{{ getTranslation("boxId") }}</p>
          <c-input :idkey="7" v-model="queryData.query.boxId" :name="'boxId'"></c-input>

          <p class="text-left">{{ getTranslation("inlayId") }}</p>
          <c-input :idkey="8" v-model="queryData.query.inlayId" :name="'inlayID'"></c-input>
        </div>

        <c-facet-dropdown :mode="'single'" :title="getTranslation('branding')"
                          :facets="facets.brands"/>

        <c-facet-dropdown :mode="'double'" :title="getTranslation('category')"
                          :facets="facets.categories"/>

        <c-facet-dropdown :mode="'singe'" :title="getTranslation('bevel')" :facets="facets.bevels"/>

        <c-facet-dropdown :mode="'singe'" :title="getTranslation('productGroup')"
                          :facets="facets.productGroups"/>

        <c-facet-dropdown :mode="'single'" :title="getTranslation('structure')"
                          :facets="facets.structures"/>

        <c-facet-dropdown :mode="'single'" :title="getTranslation('wearClass')"
                          :facets="facets.wearclasses"/>

        <div class="grid grid-rows-3">
          <div @click="onlyNewItems=!onlyNewItems"
               class="flex items-center content-center">
            <c-checkbox :selected="onlyNewItems" :mode="'large'"/>
            <label class="">{{ getTranslation('showOnlyNew') }}</label>
          </div>
          <button @click="$emit('reload-facets')"
                  class="classen__button hover__button justify-self-end">
            <p class="leading-none">{{ getTranslation('reset') }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "../../form/Input";
import DropDownFacet from "../DropDownFacet";
import CustomCheckbox from "../../form/CustomCheckbox";
import Button from "../../Button";
import getTranslation from "../../../mixins/getTranslation";

export default {
  name: "ProductFacets",

  components: {
    Button,
    'c-checkbox': CustomCheckbox,
    'c-input': Input,
    'c-facet-dropdown': DropDownFacet
  },

  props: {
    facets: {required: true, type: Object},
    opened: {required: true, type: Boolean},
    onlyNew: {required: true, type: Boolean},
    queryData: {required: false}
  },

  mixins: [getTranslation],

  watch: {
    isOpen() {
      this.$emit('update:opened', this.isOpen);
    },

    onlyNewItems() {
      this.$emit('update:onlyNew', this.onlyNewItems);
    },

  },

  created() {
  },

  data() {
    return {
      dropDownVisible: '',
      onlyNewItems: this.onlyNew,
      isOpen: this.opened,
    }
  },
}
</script>
<style scoped>
.burger {
  height: 30px;
  width: 30px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  background-color: #80695A;
}

.facet {
  box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  -webkit-box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  -moz-box-shadow: 0 0 0 2px rgba(241, 241, 241, 1);
  border-radius: 0 0 50px 0;
}
</style>
